import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { IScheduleDaypartOverride } from 'src/interfaces';
import { generateQuery, requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export const useGetScheduleDaypartOverrides = (filters: string[] = []) =>
  useQuery({
    queryKey: queryKeys.scheduleDaypartOverrides.all(filters),
    queryFn: () => fetchScheduleDaypartOverrides(filters),
  });

export const fetchScheduleDaypartOverrides = async (filters: string[] = []) => {
  const url = `/scheduleDaypartOverrides${generateQuery(
    [],
    concat(filters, 'pageSize=0'),
  )}`;

  const response = await requestCCApi({ url });

  return response.data as IScheduleDaypartOverride[];
};
